export const heroEquipment = {
  "Gang przemytników": {
    Bohaterowie: {
      "Broń wielka": [10, 0],
      Bicz: [15, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Gwiazda zaranna": [5, 0],
      Halabarda: [10, 0],
      Kostur: [5, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      Trójząb: [15, 0],
      Włócznia: [10, 0],
      "Broń miotana (noże)": [10, 1],
      Kusza: [25, 1],
      Łuk: [10, 1],
      Pistolet: [10, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Ciężki: [30, 2, "Zbroja"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
    "Kapłan Ranalda": {
      Kostur: [5, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      "Broń miotana (noże)": [10, 1],
      Bolas: [10, 1],
    },
    "Kapłan Mananna": {
      "Broń wielka": [10, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      Trójząb: [15, 0],
      Włócznia: [10, 0],
      "Broń miotana (noże)": [10, 1],
      Oszczep: [15, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Ciężki: [30, 2, "Zbroja"],
      Puklerz: [3, 2, "Tarcza"],
      Tarcza: [5, 2, "Tarcza"],
    },
    Stronnicy: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Gwiazda zaranna": [5, 0],
      Halabarda: [10, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      Włócznia: [10, 0],
      "Broń miotana (noże)": [10, 1],
      Łuk: [10, 1],
      "Łuk długi": [20, 1],
      Oszczep: [15, 1],
      Lekki: [5, 2, "Zbroja"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
    Rozbójnik: {
      Miecz: [10, 0],
      Sztylet: [2, 0],
      Włócznia: [10, 0],
      Pistolet: [10, 1],
      "Pistolet pojedynkowy": [20, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [20, 2, "Zbroja"],
      Hełm: [5, 2],
    },
    Ogr: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Cep bojowy": [10, 0],
      "Karwasz bojowy": [15, 0],
      Miecz: [10, 0],
      "Maczuga ogrów": [5, 0],
      "Topór bojowy/Nadziak": [5, 0],
      "Broń miotana (noże)": [10, 1],
      Ołowiomiotacz: [50, 1],
      Lekki: [10, 2, "Zbroja"],
      Średni: [30, 2, "Zbroja"],
    },
  },
  "Łowcy czarownic": {
    Bohaterowie: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Gwiazda zaranna": [5, 0],

      Miecz: [10, 0],
      Mizerykordia: [5, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      "Broń miotana (noże)": [10, 1],
      Kusza: [25, 1],
      Pistolet: [10, 1],
      "Pistolet pojedynkowy": [20, 1],
      "Pistolet strzałkowy": [20, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Ciężki: [30, 2, "Zbroja"],
      Puklerz: [3, 2, "Tarcza"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
          "Kadzielnica ognia": [20,0],
    },
    Stronnicy: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Cep bojowy": [10, 0],
      "Gwiazda zaranna": [5, 0],
      Korbacz: [5, 0],
      Sztylet: [2, 0],
      "Broń miotana (noże)": [10, 1],
      Łuk: [10, 1],
      "Łuk długi": [20, 1],
      Oszczep: [15, 1],
      Proca: [5, 1],
      Sieć: [10, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Puklerz: [3, 2, "Tarcza"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
    Flagelant: {
      "Broń wielka": [10, 0],
      Bicz: [15, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Cep bojowy": [10, 0],
      "Gwiazda zaranna": [5, 0],

      Korbacz: [5, 0],
          "Kadzielnica ognia": [20,0],
    },
    Rycerz: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      Kopia: [30, 0],
      Miecz: [10, 0],
      Mizerykordia: [5, 0],
      Sztylet: [2, 0],
      Włócznia: [10, 0],
      "Broń miotana (noże)": [10, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],

      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
          "Ciężki": [30,2,"Zbroja"],
    },
    Prezbiter: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Młot ulrykański": [15, 0],
      Sztylet: [2, 0],
      "Broń miotana (noże)": [10, 1],
      Pistolet: [10, 1],
      "Pistolet pojedynkowy": [20, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Ciężki: [30, 2, "Zbroja"],
      Puklerz: [3, 2, "Tarcza"],
      Tarcza: [5, 2, "Tarcza"],
    },
  },
  "Cyrkowcy z Ligii Ostermarku": {
    Bohaterowie: {
      "Broń wielka": [10, 0],
      Bicz: [15, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      Kostur: [5, 0],
      Łapacz: [10, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      Włócznia: [10, 0],
      "Broń miotana (noże)": [10, 1],
      Kusza: [25, 1],
      Pistolet: [10, 1],
      "Pistolet pojedynkowy": [20, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Ciężki: [30, 2, "Zbroja"],
      Puklerz: [3, 2, "Tarcza"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
    "Magister magii": {
      Kostur: [5, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      "Broń miotana (noże)": [10, 1],
    },
    "Kapłan Ranalda": {
      Kostur: [5, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      "Broń miotana (noże)": [10, 1],
      Bolas: [10, 1],
    },
    Stronnicy: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      Halabarda: [10, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      Włócznia: [10, 0],
      "Broń miotana (noże)": [10, 1],
      Łuk: [10, 1],
      "Łuk krótki": [5, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Puklerz: [3, 2, "Tarcza"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
    Ogr: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],

      "Karwasz bojowy": [15, 0],
      Miecz: [10, 0],
      "Maczuga ogrów": [5, 0],
      "Topór bojowy/Nadziak": [5, 0],
      "Broń miotana (noże)": [10, 1],
      Ołowiomiotacz: [50, 1],
      Lekki: [10, 2, "Zbroja"],
      Średni: [30, 2, "Zbroja"],
          "Cep bojowy": [10,0],
    },
  },
  "Muszkieterzy z Nuln": {
    Bohaterowie: {
      "Broń wielka": [10, 0],
      Bagnet: [5, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      Halabarda: [10, 0],
      Miecz: [10, 0],
      Rapier: [10, 0],
      Sztylet: [2, 0],
      "Broń miotana (ładunki wybuchowe)": [15, 1],
      "Gołąb bombardujący": [25, 1],
      Granatnik: [35, 1],
      "Muszkiet dubeltowy": [40, 1],
      "Muszkiet krasnoludzki": [25, 1],
      Pistolet: [10, 1],
      "Pistolet dubeltowy": [15, 1],
      "Pistolet pojedynkowy": [20, 1],
      Revolvera: [50, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Ciężki: [30, 2, "Zbroja"],
      Puklerz: [3, 2, "Tarcza"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
    Prezbiter: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Młot ulrykański": [15, 0],
      Sztylet: [2, 0],
      "Broń miotana (noże)": [10, 1],
      Pistolet: [10, 1],
      "Pistolet pojedynkowy": [20, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Ciężki: [30, 2, "Zbroja"],
      Puklerz: [3, 2, "Tarcza"],
      Tarcza: [5, 2, "Tarcza"],
    },
    Stronnicy: {
      "Broń wielka": [10, 0],
      Bagnet: [5, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      Halabarda: [10, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      "Broń miotana (ładunki wybuchowe)": [15, 1],
      Arkebuz: [30, 1],
      Falkonet: [40, 1],
      Garłacz: [30, 1],
      Muszkiet: [25, 1],
      "Muszkiet dubeltowy": [40, 1],
      "Muszkiet hochlandzki": [50, 1],
      Revolvera: [50, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Puklerz: [3, 2, "Tarcza"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
          "Włócznia": [10,0],
    },
    Rajtar: {
      Miecz: [10, 0],
      Sztylet: [2, 0],
      Włócznia: [10, 0],
      Pistolet: [10, 1],
      "Pistolet pojedynkowy": [20, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Hełm: [5, 2],
    },
    Ranger: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Cep bojowy": [10,0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      "Topór krasnoludów": [10, 0],
      "Broń miotana (ładunki wybuchowe)": [15, 1],
      Kusza: [25, 1],
      Oszczep: [15, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [20,2,"Zbroja"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
  },
  "Piechota Morska z Marienburga": {
    Bohaterowie: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      Korbacz: [5, 0],
      Kostur: [5, 0],
      Łamacz: [25, 0],
      Miecz: [10, 0],
      Rapier: [10, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      Trójząb: [15, 0],
      Włócznia: [10, 0],
      "Broń miotana (noże)": [10, 1],
      Łuk: [10, 1],
      "Łuk długi": [20, 1],
      Kusza: [25, 1],
      Pistolet: [10, 1],
      "Pistolet pojedynkowy": [20, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Ciężki: [30, 2, "Zbroja"],
      Puklerz: [3, 2, "Tarcza"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
    Stronnicy: {
      "Broń wielka": [10, 0],
      Bosak: [15, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      Halabarda: [10, 0],
      Korbacz: [5, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      Trójząb: [15, 0],
      Włócznia: [10, 0],
      "Broń miotana (noże)": [10, 1],
      Garłacz: [30, 1],
      Łuk: [10, 1],
      "Łuk długi": [20, 1],
      Kusza: [25, 1],
      Muszkiet: [25, 1],
      Oszczep: [15, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Puklerz: [3, 2, "Tarcza"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
    Bukanier: {
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Cep bojowy": [10, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      "Topór krasnoludów": [10, 0],
      "Broń miotana (ładunki wybuchowe)": [15, 1],
      Garłacz: [30, 1],
      Pistolet: [10, 1],
      "Pistolet pojedynkowy": [20, 1],
    },
    Ciężcy: {
      "Buława/Maczuga/Młot bojowy": [5, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      Włócznia: [10, 0],
      Harpun: [50, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
    },
    Kapłan: {
      "Broń wielka": [10, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      Trójząb: [15, 0],
      Włócznia: [10, 0],
      "Broń miotana (noże)": [10, 1],
      Oszczep: [15, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Puklerz: [3, 2, "Tarcza"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
  },
  "Siostry Sigmara": {
    Bohaterowie: {
      "Broń wielka": [10, 0],
      Bicz: [15, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Gwiazda zaranna": [5, 0],
      "Kadzielnica ognia": [20, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      "Broń miotana (noże)": [10, 1],
      Pistolet: [10, 1],
      "Pistolet pojedynkowy": [20, 1],
      Proca: [5, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Ciężki: [30, 2, "Zbroja"],
      Puklerz: [3, 2, "Tarcza"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
    Prezbiter: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Młot ulrykański": [15, 0],
      Sztylet: [2, 0],
      "Broń miotana (noże)": [10, 1],
      Pistolet: [10, 1],
      "Pistolet pojedynkowy": [20, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Ciężki: [30, 2, "Zbroja"],
      Puklerz: [3, 2, "Tarcza"],
      Tarcza: [5, 2, "Tarcza"],
    },
    Stronnicy: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Cep bojowy": [10, 0],
      "Gwiazda zaranna": [5, 0],
      Korbacz: [5, 0],
      Sztylet: [2, 0],
      "Broń miotana (noże)": [10, 1],
      Oszczep: [15, 1],
      Proca: [5,1],
      Sieć: [10,1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Puklerz: [3, 2, "Tarcza"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
    Pokutnica: {
      "Broń wielka": [10, 0],
      Bicz: [15, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Cep bojowy": [10, 0],
      "Gwiazda zaranna": [5, 0],
      "Kadzielnica ognia": [20, 0],
      Korbacz: [5, 0],
    },
    "Rycerz zakonny": {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      Kopia: [30, 0],
      Miecz: [10, 0],
      Mizerykordia: [5, 0],
      Sztylet: [2, 0],
      Włócznia: [10, 0],
      "Broń miotana (noże)": [10, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Ciężki: [30, 2, "Zbroja"],
      Tarcza: [5, 2, "Tarcza"],
    },
  },
  "Strażnicy dróg z Averlandu": {
    Bohaterowie: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Gwiazda zaranna": [5, 0],
      Halabarda: [10, 0],
      Kopia: [30, 0],
      Łamacz: [25, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      Włócznia: [10, 0],
      "Broń miotana (topory/młoty)": [15, 1],
      Kusza: [25, 1],
      Łuk: [10, 1],
      "Łuk długi": [20, 1],
      Pistolet: [10, 1],
      "Pistolet pojedynkowy": [20, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Ciężki: [30, 2, "Zbroja"],
      Puklerz: [3, 2, "Tarcza"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
    Stronnicy: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Gwiazda zaranna": [5, 0],
      Halabarda: [10, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      Włócznia: [10, 0],
      "Broń miotana (topory/młoty)": [15, 1],
      Garłacz: [30, 1],
      Kusza: [25, 1],
      Łuk: [10, 1],
      "Łuk długi": [20, 1],
      Muszkiet: [25, 1],
      "Muszkiet hochlandzki": [50, 1],
      Oszczep: [15, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Puklerz: [3, 2, "Tarcza"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
          "Bolas": [10,1],
    },
    Rajtar: {
      Miecz: [10, 0],
      Sztylet: [2, 0],
      Włócznia: [10, 0],
      Pistolet: [10, 1],
      "Pistolet pojedynkowy": [20, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [20,2,"Zbroja"],
      Hełm: [5, 2],
    },
    Pogromca: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Cep bojowy": [10, 0],
      "Topór bojowy/Nadziak": [5, 0],
      "Topór krasnoludów": [10, 0],
    },
    Prezbiter: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Młot ulrykański": [15, 0],
      Sztylet: [2, 0],
      "Broń miotana (noże)": [10, 1],
      Pistolet: [10, 1],
      "Pistolet pojedynkowy": [20, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Ciężki: [30, 2, "Zbroja"],
      Puklerz: [3, 2, "Tarcza"],
      Tarcza: [5, 2, "Tarcza"],
    },
  },
  "Zbrojna kompania z Ostlandu": {
    Bohaterowie: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Gwiazda zaranna": [5, 0],
      Łapacz: [10, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      Włócznia: [10, 0],
      Bolas: [10, 1],
      "Broń miotana (noże)": [10, 1],
      Kusza: [25, 1],
      Pistolet: [10, 1],
      "Pistolet pojedynkowy": [20, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Ciężki: [30, 2, "Zbroja"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
    Stronnicy: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Gwiazda zaranna": [5, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      Włócznia: [10, 0],
      "Broń miotana (noże)": [10, 1],
      Garłacz: [30, 1],
      Łuk: [10, 1],
      "Łuk długi": [20, 1],
      Muszkiet: [25, 1],
      "Muszkiet hochlandzki": [50, 1],
      Oszczep: [15, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
    Ogr: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Cep bojowy": [10, 0],
      "Karwasz bojowy": [15, 0],
      Miecz: [10, 0],
      "Maczuga ogrów": [5, 0],
      "Topór bojowy/Nadziak": [5, 0],
      "Broń miotana (noże)": [10, 1],
      Ołowiomiotacz: [50, 1],
      Lekki: [10, 2, "Zbroja"],
      Średni: [30, 2, "Zbroja"],
    },
    Prezbiter: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Młot ulrykański": [15, 0],
      Sztylet: [2, 0],
      "Broń miotana (noże)": [10, 1],
      Pistolet: [10, 1],
      "Pistolet pojedynkowy": [20, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Ciężki: [30, 2, "Zbroja"],
      Puklerz: [3, 2, "Tarcza"],
      Tarcza: [5, 2, "Tarcza"],
    },
  },
  "Zbrojni z Middenheim": {
    Bohaterowie: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Cep bojowy": [10, 0],
      "Gwiazda zaranna": [5, 0],
      Korbacz: [5, 0],
      Miecz: [10, 0],
      "Młot ulrykański": [15, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      Włócznia: [10, 0],
      "Broń miotana (topory/młoty)": [15, 1],
      Łuk: [10, 1],
      "Łuk długi": [20, 1],
      "Łuk krótki": [5, 1],
      Oszczep: [15, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Ciężki: [30, 2, "Zbroja"],
      Puklerz: [3, 2, "Tarcza"],
      Tarcza: [5, 2, "Tarcza"],
    },
    Stronnicy: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Cep bojowy": [10, 0],
      "Gwiazda zaranna": [5, 0],
      Korbacz: [5, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      Włócznia: [10, 0],
      "Broń miotana (topory/młoty)": [15, 1],
      Łuk: [10, 1],
      "Łuk długi": [20, 1],
      "Łuk krótki": [5, 1],
      Oszczep: [15, 1],
      Proca: [5, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Hełm: [5, 2],
      Puklerz: [3, 2, "Tarcza"],
      Tarcza: [5, 2, "Tarcza"],
    },
    Kapłan: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Młot ulrykański": [15, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      "Broń miotana (topory/młoty)": [15, 1],
      Oszczep: [15, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Ciężki: [30, 2, "Zbroja"],
      Tarcza: [5, 2, "Tarcza"],
    },
  },
  "Żołnierze z Reiklandu": {
    Bohaterowie: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Gwiazda zaranna": [5, 0],
      Halabarda: [10, 0],
      Kopia: [30, 0],
      Łamacz: [25, 0],
      Miecz: [10, 0],
      Rapier: [10, 0],
      Sztylet: [2, 0],
      Włócznia: [10, 0],
      "Broń miotana (noże)": [10, 1],
      Łuk: [10, 1],
      "Łuk długi": [20, 1],
      Kusza: [25, 1],
      Pistolet: [10, 1],
      "Pistolet pojedynkowy": [20, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Ciężki: [30, 2, "Zbroja"],
      Puklerz: [3, 2, "Tarcza"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
    Prezbiter: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Młot ulrykański": [15, 0],
      Sztylet: [2, 0],
      "Broń miotana (noże)": [10, 1],
      Pistolet: [10, 1],
      "Pistolet pojedynkowy": [20, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Ciężki: [30, 2, "Zbroja"],
      Puklerz: [3, 2, "Tarcza"],
      Tarcza: [5, 2, "Tarcza"],
    },
    Stronnicy: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Gwiazda zaranna": [5, 0],
      Halabarda: [10, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      Włócznia: [10, 0],
      "Broń miotana (noże)": [10, 1],
      Garłacz: [30, 1],
      Łuk: [10, 1],
      "Łuk długi": [20, 1],
      Kusza: [25, 1],
      Muszkiet: [25, 1],
      "Muszkiet hochlandzki": [50, 1],
      Oszczep: [15, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Puklerz: [3, 2, "Tarcza"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
    Rajtar: {
      Miecz: [10, 0],
      Sztylet: [2, 0],
      Włócznia: [10, 0],
      Pistolet: [10, 1],
      "Pistolet pojedynkowy": [20, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Hełm: [5, 2],
    },
    Flagelant: {
      "Broń wielka": [10, 0],
      Bicz: [15, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Cep bojowy": [10, 0],
      "Gwiazda zaranna": [5, 0],

      Korbacz: [5, 0],
          "Kadzielnica ognia": [20,0],
    },
  },
  "Rycerze Graala": {
    Bohaterowie: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Gwiazda zaranna": [5, 0],
      Halabarda: [10, 0],
      Kopia: [30, 0],
      Kostur: [5, 0],
      Łamacz: [25, 0],
      Miecz: [10, 0],
      Mizerykordia: [5, 0],
      Rapier: [10, 0],
      Sztylet: [2, 0],
      Włócznia: [10, 0],
      "Broń miotana (topory/młoty)": [15, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Ciężki: [30, 2, "Zbroja"],
      Puklerz: [3, 2, "Tarcza"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
      Rumak: [55, 3],
    },
    Rycerz: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Gwiazda zaranna": [5, 0],
      Halabarda: [10, 0],
      Kopia: [30, 0],
      Kostur: [5, 0],
      Łamacz: [25, 0],
      Miecz: [10, 0],
      Rapier: [10, 0],
      Sztylet: [2, 0],
      Włócznia: [10, 0],
      "Broń miotana (topory/młoty)": [15, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Ciężki: [30, 2, "Zbroja"],
      Puklerz: [3, 2, "Tarcza"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
      Rumak: [55, 3],
      "Cnota doskonałości": [0, 3, "Choice"],
      "Cnota dyscypliny": [0, 3, "Choice"],
      "Cnota męstwa": [0, 3, "Choice"],
      "Cnota pobożności": [0, 3, "Choice"],
      "Cnota wiary": [0, 3, "Choice"],
      "Cnota wyszkolenia": [0, 3, "Choice"],
    },
    Stronnicy: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Cep bojowy": [10, 0],
      "Gwiazda zaranna": [5, 0],
      Halabarda: [10, 0],
      Korbacz: [5,0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      Włócznia: [10, 0],
      "Broń miotana (topory/młoty)": [15, 1],
      Łuk: [10, 1],
      "Łuk długi": [20, 1],
      Oszczep: [15, 1],
      Proca: [5, 1],
      Sieć: [10, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Puklerz: [3, 2, "Tarcza"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
    Zbrojny: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Cep bojowy": [10, 0],
      "Gwiazda zaranna": [5, 0],
      Halabarda: [10, 0],
      Korbacz: [10, 0],
      Miecz: [10, 0, "Startowy"],
      Sztylet: [2, 0],
      Włócznia: [10, 0],
      "Broń miotana (topory/młoty)": [15, 1],
      Łuk: [10, 1, "Startowy"],
      "Łuk długi": [20, 1],
      Oszczep: [15, 1],
      Proca: [5, 1],
      Sieć: [10, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Puklerz: [3, 2, "Tarcza"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
    Pielgrzym: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Cep bojowy": [10, 0],
      "Gwiazda zaranna": [5, 0],
      Korbacz: [5,0],
      Miecz: [10, 0],
    },
    Błędny: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      Kopia: [30, 0],
      Miecz: [10, 0],
      Mizerykordia: [5, 0],
      Sztylet: [2, 0],
      Włócznia: [10, 0],
      "Broń miotana (topory/młoty)": [15, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Ciężki: [30, 2, "Zbroja"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
  },
  "Zbrojna chorągiew z Kisleva": {
    Bohaterowie: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      Halabarda: [10, 0],
      Łapacz: [10, 0],
      Kopia: [30, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      Włócznia: [10, 0],
      "Broń miotana (topory/młoty)": [15, 1],
      Kusza: [25, 1],
      Łuk: [10, 1],
      Pistolet: [10, 1],
      "Pistolet pojedynkowy": [20, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Ciężki: [30, 2, "Zbroja"],
      Puklerz: [3, 2, "Tarcza"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
    Stronnicy: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      Halabarda: [10, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      Włócznia: [10, 0],
      "Broń miotana (topory/młoty)": [15, 1],
      Kusza: [25, 1],
      Łuk: [10, 1],
      "Łuk długi": [20, 1],
      Muszkiet: [25, 1],
      Oszczep: [15, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Puklerz: [3, 2, "Tarcza"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
    Nomada: {
      "Buława/Maczuga/Młot bojowy": [5, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      Włócznia: [10, 0],
      "Broń miotana (topory/młoty)": [15, 1],
      "Łuk krótki": [5, 1],
      Oszczep: [15, 1],
      Lekki: [5, 2, "Zbroja"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
    Husarz: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      Kopia: [30, 0],
      Miecz: [10, 0],
      Mizerykordia: [5, 0],
      Sztylet: [2, 0],
      Włócznia: [10, 0],
      "Broń miotana (topory/młoty)": [15, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Ciężki: [30, 2, "Zbroja"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
    Magister: {
      Kostur: [5, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      "Broń miotana (topory/młoty)": [15, 1],
    },
    Kapłan: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      "Topór krasnoludów": [10, 0],
      "Broń miotana (topory/młoty)": [15, 1],
      Oszczep: [15, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Ciężki: [30, 2, "Zbroja"],
      Tarcza: [5, 2, "Tarcza"],
    },
  },
  "Piraci z Sartosy": {
    Bohaterowie: {
      "Broń wielka": [10, 0],
      Bicz: [15, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      Halabarda: [10, 0],
      Korbacz: [5, 0],
      Kostur: [5, 0],
      Łamacz: [25, 0],
      Łapacz: [10, 0],
      Miecz: [10, 0],
      Rapier: [10, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      Trójząb: [15, 0],
      Włócznia: [10, 0],
      "Broń miotana (noże)": [10, 1],
      Łuk: [10, 1],
      Kusza: [25, 1],
      Pistolet: [10, 1],
      "Pistolet pojedynkowy": [20, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Ciężki: [30, 2, "Zbroja"],
      Puklerz: [3, 2, "Tarcza"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
    Stronnicy: {
      "Broń wielka": [10, 0],
      Bosak: [15, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      Halabarda: [10, 0],
      Korbacz: [5, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      Trójząb: [15, 0],
      Włócznia: [10, 0],
      "Broń miotana (noże)": [10, 1],
      Garłacz: [30, 1],
      Łuk: [10, 1],
      Kusza: [25, 1],
      Muszkiet: [25, 1],
      Oszczep: [15, 1],
      Pistolet: [10, 1],
      Sieć: [10, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Puklerz: [3, 2, "Tarcza"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
    Ciężcy: {
      "Buława/Maczuga/Młot bojowy": [5, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      Włócznia: [10, 0],
      Harpun: [50, 1],
      Ołowiomiotacz: [50, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
    },
    Ogr: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],

      "Karwasz bojowy": [15, 0],
      Miecz: [10, 0],
      "Maczuga ogrów": [5, 0],
      "Topór bojowy/Nadziak": [5, 0],
      "Broń miotana (noże)": [10, 1],
      Ołowiomiotacz: [50, 1],
      Lekki: [10, 2, "Zbroja"],
      Średni: [30, 2, "Zbroja"],
          "Cep bojowy": [10,0],
    },
    Kapłan: {
      "Broń wielka": [10, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      Trójząb: [15, 0],
      Włócznia: [10, 0],
      "Broń miotana (noże)": [10, 1],
      Oszczep: [15, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Puklerz: [3, 2, "Tarcza"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
  },
  "Gladiatorzy z Jałowej Krainy": {
    Bohaterowie: {
      "Broń wielka": [10, 0],
      Bicz: [15, 0],
      Bosak: [15, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Cep bojowy": [10, 0],
      "Gwiazda zaranna": [5, 0],
      "Karwasz bojowy": [15, 0],
      Korbacz: [5, 0],
      Kostur: [5, 0],
      Łamacz: [25, 0],
      Łapacz: [10, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      Trójząb: [15, 0],
      Włócznia: [10, 0],
      "Broń miotana (noże)": [10, 1],
      Oszczep: [15, 1],
      Sieć: [10, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Ciężki: [30, 2, "Zbroja"],
      Puklerz: [3, 2, "Tarcza"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
    Stronnicy: {
      "Broń wielka": [10, 0],
      Bosak: [15, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Cep bojowy": [10, 0],
      "Gwiazda zaranna": [5, 0],
      Halabarda: [10, 0],
      "Karwasz bojowy": [15, 0],
      Korbacz: [5, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      Trójząb: [15, 0],
      Włócznia: [10, 0],
      "Broń miotana (noże)": [10, 1],
      "Łuk krótki": [5, 1],
      Oszczep: [15, 1],
      Proca: [5, 1],
      Sieć: [10, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Puklerz: [3, 2, "Tarcza"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
    Ogr: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Cep bojowy": [10, 0],
      "Karwasz bojowy": [15, 0],
      Miecz: [10, 0],
      "Maczuga ogrów": [5, 0],
      "Topór bojowy/Nadziak": [5, 0],
      "Broń miotana (noże)": [10, 1],
      Ołowiomiotacz: [50, 1],
      Lekki: [10, 2, "Zbroja"],
    },
    Pogromca: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Cep bojowy": [10, 0],
      "Topór bojowy/Nadziak": [5, 0],
      "Topór krasnoludów": [10, 0],
    },
    Nomada: {
      "Buława/Maczuga/Młot bojowy": [5, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      Włócznia: [10, 0],
      "Broń miotana (noże)": [10, 1],
      "Łuk krótki": [5, 1],
      Oszczep: [15, 1],
      Lekki: [5, 2, "Zbroja"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
  },
  "Psy Wojny": {
    Bohaterowie: {
      "Broń wielka": [10, 0],
      Bicz: [15, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Cep bojowy": [10, 0],
      "Gwiazda zaranna": [5, 0],
      Halabarda: [10, 0],
      Kopia: [30, 0],
      Korbacz: [5, 0],
      Kostur: [5, 0],
      Łamacz: [25, 0],
      Miecz: [10, 0],
      Rapier: [10, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      Trójząb: [15, 0],
      Włócznia: [10, 0],
      "Broń miotana (noże)": [10, 1],
      Kusza: [25, 1],
      Łuk: [10, 1],
      "Łuk długi": [20, 1],
      "Łuk krótki": [5, 1],
      Oszczep: [15, 1],
      Pistolet: [10, 1],
      "Pistolet pojedynkowy": [20, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Ciężki: [30, 2, "Zbroja"],
      Puklerz: [3, 2, "Tarcza"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
    Stronnicy: {
      "Broń wielka": [10, 0],
      Bosak: [15, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Cep bojowy": [10, 0],
      "Gwiazda zaranna": [5, 0],
      Halabarda: [10, 0],
      Korbacz: [5, 0],
      Miecz: [10, 0],
      Pika: [15, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      Trójząb: [15, 0],
      Włócznia: [10, 0],
      "Broń miotana (noże)": [10, 1],
      Kusza: [25, 1],
      Łuk: [10, 1],
      "Łuk długi": [20, 1],
      "Łuk krótki": [5, 1],
      Muszkiet: [25, 1],
      "Muszkiet hochlandzki": [50, 1],
      Oszczep: [15, 1],
      Proca: [5, 1],
      Sieć: [10, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Puklerz: [3, 2, "Tarcza"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
    Ogr: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Cep bojowy": [10, 0],
      "Karwasz bojowy": [15, 0],
      Miecz: [10, 0],
      "Maczuga ogrów": [5, 0],
      "Topór bojowy/Nadziak": [5, 0],
      "Broń miotana (noże)": [10, 1],
      Ołowiomiotacz: [50, 1],
      Lekki: [10, 2, "Zbroja"],
      Średni: [30, 2, "Zbroja"],
    },
    Kapłan: {
      "Broń wielka": [10, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      Włócznia: [10, 0],
      "Broń miotana (noże)": [10, 1],
      Oszczep: [15, 1],
      Pistolet: [10, 1],
      "Pistolet pojedynkowy": [20, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Ciężki: [30, 2, "Zbroja"],
      Puklerz: [3, 2, "Tarcza"],
      Tarcza: [5, 2, "Tarcza"],
    },
    Lansjer: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      Korbacz: [5, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      Włócznia: [10, 0],
      "Broń miotana (noże)": [10, 1],
      Oszczep: [15, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
  },
  "Raubritterzy z Księstw Granicznych": {
    Bohaterowie: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Gwiazda zaranna": [5, 0],
      Halabarda: [10, 0],
      Kostur: [5, 0],
      Kopia: [30, 0],
      Łapacz: [10, 0],
      Miecz: [10, 0],
      Mizerykordia: [5, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      Włócznia: [10, 0],
      Bolas: [10, 1],
      "Broń miotana (noże)": [10, 1],
      Kusza: [25, 1],
      Pistolet: [10, 1],
      "Pistolet pojedynkowy": [20, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Ciężki: [30, 2, "Zbroja"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
    Stronnicy: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Gwiazda zaranna": [5, 0],
      Halabarda: [10, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      Włócznia: [10, 0],
      "Broń miotana (noże)": [10, 1],
      Garłacz: [30, 1],
      Łuk: [10, 1],
      "Łuk długi": [20, 1],
      Muszkiet: [25, 1],
      Oszczep: [15, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
    Rozbójnik: {
      Miecz: [10, 0],
      Sztylet: [2, 0],
      Włócznia: [10, 0],
      Pistolet: [10, 1],
      "Pistolet pojedynkowy": [20, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [20,2,"Zbroja"],
      Hełm: [5, 2],
    },
    Ogr: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Cep bojowy": [10, 0],
      "Karwasz bojowy": [15, 0],
      Miecz: [10, 0],
      "Maczuga ogrów": [5, 0],
      "Topór bojowy/Nadziak": [5, 0],
      "Broń miotana (noże)": [10, 1],
      Ołowiomiotacz: [50, 1],
      Lekki: [10, 2, "Zbroja"],
      Średni: [30, 2, "Zbroja"],
    },
  },
  "Kupiecka karawana z Arabii": {
    Bohaterowie: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      Chopesz: [10, 0],
      Halabarda: [10, 0],
      Kostur: [5, 0],
      Łapacz: [10, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      Włócznia: [10, 0],
      Bolas: [10, 1],
      "Broń miotana (noże)": [15,1],
      Łuk: [10, 1],
      "Łuk długi": [20, 1],
      Oszczep: [15, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Ciężki: [30, 2, "Zbroja"],
      Puklerz: [3, 2, "Tarcza"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
          "Bicz": [15,0],
    },
    Stronnicy: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      Chopesz: [10, 0],
      Halabarda: [10, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      Włócznia: [10, 0],
      "Broń miotana (noże)": [15,1],
      Łuk: [10, 1],
      "Łuk długi": [20, 1],
      Muszkiet: [25, 1],
      "Muszkiet hochlandzki": [50, 1],
      Oszczep: [15, 1],
      Proca: [5, 1],
      Sieć: [10, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Puklerz: [3, 2, "Tarcza"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
    Nomada: {
      "Buława/Maczuga/Młot bojowy": [5, 0],
      Chopesz: [10, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      Włócznia: [10, 0],

      "Łuk krótki": [5, 1],
      Oszczep: [15, 1],
      Lekki: [5, 2, "Zbroja"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
          "Broń miotana (noże)": [10,1],
    },
    Derwisz: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Cep bojowy": [10, 0],
      Chopesz: [10, 0],
      "Gwiazda zaranna": [5, 0],
      Korbacz: [5, 0],
    },
  },
  "Amazonki z Lustrii": {
    Bohaterowie: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      Halabarda: [10, 0],
      Khutar: [30, 0],
      Kostur: [5, 0],
      "Gwiazda zaranna": [5, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      Włócznia: [10, 0],
      "Broń miotana (noże)": [10, 1],
      Łuk: [10, 1],
      "Łuk długi": [20, 1],
      Proca: [5, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Puklerz: [3, 2, "Tarcza"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
    Stronnicy: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Gwiazda zaranna": [5, 0],
      Halabarda: [10, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      Włócznia: [10, 0],
      "Broń miotana (noże)": [10, 1],
      Łuk: [10, 1],
      "Łuk długi": [20, 1],
      Oszczep: [15, 1],
      Proca: [5, 1],
      Sieć: [10, 1],
      Lekki: [5, 2, "Zbroja"],
      Puklerz: [3, 2, "Tarcza"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
    Mara: {
      "Broń wielka": [10, 0],
      Khutar: [30, 0],
      "Gwiazda zaranna": [5, 0],
      Miecz: [10, 0],
      Włócznia: [10, 0],
    },
    Walkiria: {
      "Buława/Maczuga/Młot bojowy": [5, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      Włócznia: [10, 0],
      "Broń miotana (noże)": [10, 1],
      "Łuk krótki": [5, 1],
      Oszczep: [15, 1],
      Lekki: [5, 2, "Zbroja"],
      Tarcza: [5, 2, "Tarcza"],
    },
  },
  "Nizołki z Krainy Zgromadzenia": {
    Bohaterowie: {

      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Gwiazda zaranna": [5, 0],
      Halabarda: [10, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      Włócznia: [10, 0],
      "Broń miotana (noże)": [10, 1],
      Kusza: [25, 1],
      Łuk: [10, 1],
      Pistolet: [10, 1],
      "Pistolet pojedynkowy": [20, 1],
      Proca: [5, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Ciężki: [30, 2, "Zbroja"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
          "Broń Wielka": [10,0],
    },
    Magister: {
      Kostur: [5, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      "Broń miotana (noże)": [10, 1],
    },
    Stronnicy: {

      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Gwiazda zaranna": [5, 0],
      Halabarda: [10, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      Włócznia: [10, 0],
      "Broń miotana (noże)": [10, 1],
      "Łuk krótki": [5, 1],
      Łuk: [10, 1],
      Oszczep: [15, 1],
      Proca: [5, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
          "Broń Wielka": [10,0],
    },
    Ogr: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],

      "Karwasz bojowy": [15, 0],
      Miecz: [10, 0],
      "Maczuga ogrów": [5, 0],
      "Topór bojowy/Nadziak": [5, 0],
      "Broń miotana (noże)": [10, 1],
      Ołowiomiotacz: [50, 1],
      Lekki: [10, 2, "Zbroja"],
      Średni: [30, 2, "Zbroja"],
          "Cep bojowy": [10,0],
    },
  },
  "Leśni Elfowie z Athel Loren": {
    Bohaterowie: {
      "Broń wielka": [10, 0],
      Kostur: [5, 0],
      Miecz: [10, 0],
      Saearath: [15, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      Włócznia: [10, 0],
      "Broń miotana (topory/młoty)": [15, 1],
      Łuk: [10, 1],
      "Łuk elfów": [35, 1],
      "Łuk długi": [20, 1],
      Oszczep: [15, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      "Pancerz z Ithilmaru": [50, 2, "Zbroja"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
    Mag: {
      Kostur: [5, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      Włócznia: [10, 0],
      "Broń miotana (topory/młoty)": [15, 1],
      "Łuk elfów": [35, 1],
      Oszczep: [15, 1],
    },
    Stronnicy: {
      "Broń wielka": [10, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      Włócznia: [10, 0],
      "Broń miotana (topory/młoty)": [15, 1],
      Łuk: [10, 1],
      "Łuk długi": [20, 1],
      Oszczep: [15, 1],
      Proca: [5, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Puklerz: [3, 2, "Tarcza"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
    Jeździec: {
      Miecz: [10, 0],
      Sztylet: [2, 0],
      Włócznia: [10, 0],
      "Broń miotana (topory/młoty)": [15, 1],

      "Łuk długi": [20, 1],
      Oszczep: [15, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
          "Łuk elfów": [35,1],
    },
    Tancerz: {
      "Broń wielka": [10, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      Włócznia: [10, 0],
      "Broń miotana (topory/młoty)": [15, 1],
          "Saearath": [15,0],
    },
  },
  "Elfowie Wysokiego Rodu z Ulthuanu": {
    Bohaterowie: {
      "Broń wielka": [10, 0],
      Halabarda: [10, 0],
      Kopia: [30, 0],
      Łamacz: [25, 0],
      Miecz: [10, 0],
      Mizerykordia: [5, 0],
      Rapier: [10, 0],
      Sztylet: [2, 0],
      "Topór z Chrace": [25, 0],
      Włócznia: [10, 0],
      "Broń miotana (noże)": [10, 1],
      Łuk: [10, 1],
      "Łuk długi": [20, 1],
      Oszczep: [15, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Ciężki: [30, 2, "Zbroja"],
      "Pancerz z Ithilmaru": [50, 2, "Zbroja"],
      Puklerz: [3, 2, "Tarcza"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
    Mag: {
      Kostur: [5, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      Włócznia: [10, 0],
      "Broń miotana (noże)": [10, 1],
    },
    Stronnicy: {
      "Broń wielka": [10, 0],
      Halabarda: [10, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      Włócznia: [10, 0],
      "Broń miotana (noże)": [10, 1],
      Łuk: [10, 1],
      "Łuk długi": [20, 1],
      Oszczep: [15, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Puklerz: [3, 2, "Tarcza"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
    Srebrny: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      Kopia: [30, 0],
      Miecz: [10, 0],
      Mizerykordia: [5, 0],
      Sztylet: [2, 0],
      Włócznia: [10, 0],
      "Broń miotana (noże)": [10, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Ciężki: [30, 2, "Zbroja"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
  },
  "Mroczni Elfowie z Naggaroth": {
    Bohaterowie: {
      "Broń wielka": [10, 0],
      Bicz: [15, 0],
      Draich: [25, 0],
      Halabarda: [10, 0],
      Kopia: [30, 0],
      Łapacz: [10, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      Włócznia: [10, 0],

      "Broń miotana (noże)": [10, 1],
      Kusza: [25, 1],
      "Kusza powtarzalna": [25, 1],
      "Pistolet strzałkowy powtarzalny": [20, 1],
      Oszczep: [15, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Ciężki: [30, 2, "Zbroja"],
      "Pancerz z Ithilmaru": [50, 2, "Zbroja"],
      Puklerz: [3, 2, "Tarcza"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
          "Arkan/Bolas/Sieć": [10,1],
    },
    Mag: {
      Kostur: [5, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      Włócznia: [10, 0],
      "Broń miotana (noże)": [10, 1],
    },
    Stronnicy: {
      "Broń wielka": [10, 0],
      Halabarda: [10, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      Włócznia: [10, 0],
      "Broń miotana (noże)": [10, 1],
      Kusza: [25, 1],
      "Kusza powtarzalna": [25, 1],
      Oszczep: [15, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Puklerz: [3, 2, "Tarcza"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
    Wiedźma: {
      "Broń wielka": [10, 0],
      Bicz: [15, 0],
      Draich: [25, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      Włócznia: [10, 0],
      "Broń miotana (noże)": [10, 1],
    },
    Jeździec: {
      Miecz: [10, 0],
      Kopia: [30, 0],
      Sztylet: [2, 0],
      Włócznia: [10, 0],
      "Broń miotana (noże)": [10, 1],
      "Kusza powtarzalna": [25, 1],
      Sieć: [10, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],

      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
  },
  "Khazadzi z Gór Krańca Świata": {
    Bohaterowie: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Cep bojowy": [10, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      "Topór krasnoludów": [10, 0],
      "Broń miotana (ładunki wybuchowe)": [15, 1],
      Kusza: [25, 1],
      "Muszkiet krasnoludzki": [25, 1],
      "Pistolet dubeltowy": [15, 1],
      "Pistolet pojedynkowy": [20, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Ciężki: [30, 2, "Zbroja"],
      "Pancerz z Gromrilu": [50, 2, "Zbroja"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
    Stronnicy: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Cep bojowy": [10, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      "Topór krasnoludów": [10, 0],
      "Broń miotana (ładunki wybuchowe)": [15, 1],
      Garłacz: [30, 1],
      Kusza: [25, 1],
      "Muszkiet krasnoludzki": [25, 1],
      Oszczep: [15, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
    Strzelec: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Cep bojowy": [10, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      "Topór krasnoludów": [10, 0],
      "Broń miotana (ładunki wybuchowe)": [15, 1],
      Garłacz: [30, 1],
      Kusza: [25, 1, "Startowy"],
      "Muszkiet krasnoludzki": [25, 1, "Startowy"],
      Oszczep: [15, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
    Pogromca: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Cep bojowy": [10, 0],
      "Topór bojowy/Nadziak": [5, 0],
      "Topór krasnoludów": [10, 0],
    },
  },
  "Kompania krasnoludzkich Piwowarów": {
    Bohaterowie: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Cep bojowy": [10, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      "Topór krasnoludów": [10, 0],
      "Broń miotana (ładunki wybuchowe)": [15, 1],
      Kusza: [25, 1],
      "Muszkiet krasnoludzki": [25, 1],
      "Pistolet dubeltowy": [15, 1],
      "Pistolet pojedynkowy": [20, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Ciężki: [30, 2, "Zbroja"],
      "Pancerz z Gromrilu": [50, 2, "Zbroja"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
    Zwiadowca: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Cep bojowy": [10, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      "Topór krasnoludów": [10, 0],
      "Broń miotana (ładunki wybuchowe)": [15, 1],
      Kusza: [25, 1, "Startowy"],
      "Muszkiet krasnoludzki": [25, 1, "Startowy"],
      "Pistolet dubeltowy": [15, 1],
      "Pistolet pojedynkowy": [20, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Ciężki: [30, 2, "Zbroja"],
      "Pancerz z Gromrilu": [50, 2, "Zbroja"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
    Stronnicy: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Cep bojowy": [10, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      "Topór krasnoludów": [10, 0],
      "Broń miotana (ładunki wybuchowe)": [15, 1],
      Garłacz: [30, 1],
      Kusza: [25, 1],
      "Muszkiet krasnoludzki": [25, 1],
      Oszczep: [15, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
    Pogromca: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Cep bojowy": [10, 0],
      "Topór bojowy/Nadziak": [5, 0],
      "Topór krasnoludów": [10, 0],
    },
  },
  "Kult Pogromców z Karak Kadrin": {
    Bohaterowie: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Cep bojowy": [10, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      "Topór krasnoludów": [10, 0],
      "Broń miotana (ładunki wybuchowe)": [15, 1],
      Kusza: [25, 1],
      "Muszkiet krasnoludzki": [25, 1],
      "Pistolet dubeltowy": [15, 1],
      "Pistolet pojedynkowy": [20, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Ciężki: [30, 2, "Zbroja"],
      "Pancerz z Gromrilu": [50, 2, "Zbroja"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
    Stronnicy: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Cep bojowy": [10, 0],
      "Topór bojowy/Nadziak": [5, 0],
      "Topór krasnoludów": [10, 0],
      "Broń miotana (ładunki wybuchowe)": [15, 1],
    },
    Bukanier: {
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Cep bojowy": [10, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      "Topór krasnoludów": [10, 0],
      "Broń miotana (ładunki wybuchowe)": [15, 1],
      Garłacz: [30, 1],
      Pistolet: [10, 1],
      "Pistolet pojedynkowy": [20, 1],
    },
  },
  "Szkutnicy z Barak Varr": {
    Bohaterowie: {
      "Broń wielka": [10, 0],
      Bagnet: [5, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Cep bojowy": [10, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      "Topór krasnoludów": [10, 0],
      "Broń miotana (ładunki wybuchowe)": [15, 1],
      Granatnik: [35, 1],
      Kusza: [25, 1],
      "Muszkiet krasnoludzki": [25, 1],
      "Pistolet dubeltowy": [15, 1],
      "Pistolet pojedynkowy": [20, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Ciężki: [30, 2, "Zbroja"],
      "Pancerz z Gromrilu": [50, 2, "Zbroja"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
    Zwiadowca: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Cep bojowy": [10, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      "Topór krasnoludów": [10, 0],
      "Broń miotana (ładunki wybuchowe)": [15, 1],
      Granatnik: [35, 1],
      Kusza: [25, 1, "Startowy"],
      "Muszkiet krasnoludzki": [25, 1, "Startowy"],
      "Pistolet dubeltowy": [15, 1],
      "Pistolet pojedynkowy": [20, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Ciężki: [30, 2, "Zbroja"],
      "Pancerz z Gromrilu": [50, 2, "Zbroja"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
    Stronnicy: {
      "Broń wielka": [10, 0],
      Bagnet: [5, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Cep bojowy": [10, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      "Topór krasnoludów": [10, 0],
      "Broń miotana (ładunki wybuchowe)": [15, 1],
      Arkebuz: [30, 1],
      Garłacz: [30, 1],
      Kusza: [25, 1],
      "Muszkiet krasnoludzki": [25, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
    Bukanier: {
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Cep bojowy": [10, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      "Topór krasnoludów": [10, 0],
      "Broń miotana (ładunki wybuchowe)": [15, 1],
      Garłacz: [30, 1],
      Pistolet: [10, 1],
      "Pistolet pojedynkowy": [20, 1],
    },
    Ogr: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],

      "Karwasz bojowy": [15, 0],
      Miecz: [10, 0],
      "Maczuga ogrów": [5, 0],
      "Topór bojowy/Nadziak": [5, 0],
      "Broń miotana (noże)": [10, 1],
      Ołowiomiotacz: [50, 1],
      Lekki: [10, 2, "Zbroja"],
      Średni: [30, 2, "Zbroja"],
          "Cep bojowy": [10,0],
    },
  },
  "Krasnoludowie Chaosu z Zorn Uzkul": {
    Czarnoksiężnik: {
      Kostur: [5, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      "Broń miotana (ładunki wybuchowe)": [15, 1],
      "Pistolet pojedynkowy": [20, 1],
    },
    Hobgoblin: {
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Cep bojowy": [10, 0],
      "Topór bojowy/Nadziak": [5, 0],
      Włócznia: [10, 0],
      "Broń miotana (noże)": [10, 1],
      Łuk: [10, 1],
      Oszczep: [15, 1],
      Sieć: [10, 1],
      Lekki: [5, 2, "Zbroja"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
    Bohaterowie: {
      "Broń wielka": [10, 0],
      Bagnet: [5, 0],
      Bicz: [15, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      Halabarda: [10, 0],
      Łapacz: [10, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],

      "Broń miotana (ładunki wybuchowe)": [15, 1],
      Granatnik: [35, 1],
      "Muszkiet krasnoludzki": [25, 1],
      "Pistolet dubeltowy": [15, 1],
      "Pistolet pojedynkowy": [20, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Ciężki: [30, 2, "Zbroja"],
      "Pancerz z Gromrilu": [50, 2, "Zbroja"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
          "Arkan/Bolas/Sieć": [10,1],
    },
    Stronnicy: {
      "Broń wielka": [10, 0],
      Bagnet: [5, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      "Broń miotana (ładunki wybuchowe)": [15, 1],
      Arkebuz: [30, 1],
      Falkonet: [40, 1],
      Garłacz: [30, 1],
      "Muszkiet krasnoludzki": [25, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
  },
  "Jeźdźcy Wilków": {
    Bohaterowie: {
      "Broń wielka": [10, 0],
      Bicz: [15, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Gwiazda zaranna": [5, 0],
      Kostur: [5, 0],
      Łapacz: [10, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      Włócznia: [10, 0],
      "Broń miotana (noże)": [10, 1],
      "Arkan/Bolas/Sieć": [10, 1],
      Kusza: [25, 1],
      Łuk: [10, 1],
      Oszczep: [15, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Ciężki: [30, 2, "Zbroja"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
      "Wielki wilk": [55, 3],
    },
    Hobgoblin: {
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Cep bojowy": [10, 0],
      "Topór bojowy/Nadziak": [5, 0],
      Włócznia: [10, 0],
      "Broń miotana (noże)": [10, 1],
      Łuk: [10, 1],
      Oszczep: [15, 1],
      Sieć: [10, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
    Stronnicy: {
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Cep bojowy": [10, 0],
      "Topór bojowy/Nadziak": [5, 0],
      Włócznia: [10, 0],
      "Broń miotana (noże)": [10, 1],
      Łuk: [10, 1],
      Oszczep: [15, 1],
      Sieć: [10, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
    Ogr: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],

      "Karwasz bojowy": [15, 0],
      Miecz: [10, 0],
      "Maczuga ogrów": [5, 0],
      "Topór bojowy/Nadziak": [5, 0],
      "Broń miotana (noże)": [10, 1],
      Ołowiomiotacz: [50, 1],
      Lekki: [10, 2, "Zbroja"],
      Średni: [30, 2, "Zbroja"],
          "Cep bojowy": [10,0],
    },
  },
  "Zwiadowcza kompania z Królestw Ogrów": {
    Bohaterowie: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],

      "Karwasz bojowy": [15, 0],
      Miecz: [10, 0],
      "Maczuga ogrów": [5, 0],
      "Topór bojowy/Nadziak": [5, 0],
      Włócznia: [10, 0],
      "Broń miotana (noże)": [10, 1],
      Harpun: [50, 1],
      Oszczep: [15, 1],
      "Wnyk łańcuchowy": [15, 1],
      Lekki: [10, 2, "Zbroja"],
      Średni: [30, 2, "Zbroja"],
      Ciężki: [60, 2, "Zbroja"],
      Hełm: [5, 2],
          "Cep bojowy": [10,0],
    },
    Ogniobrzuchy: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Cep bojowcy": [10, 0],
      "Karwasz bojowy": [15, 0],
      Miecz: [10, 0],
      "Maczuga ogrów": [5, 0],
      "Topór bojowy/Nadziak": [5, 0],
      Włócznia: [10, 0],
      "Broń miotana (noże)": [10, 1],
      Oszczep: [15, 1],
    },
    Rzeźnik: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Cep bojowcy": [10, 0],
      "Karwasz bojowy": [15, 0],
      Miecz: [10, 0],
      "Maczuga ogrów": [5, 0],
      "Topór bojowy/Nadziak": [5, 0],
      Włócznia: [10, 0],
      "Broń miotana (noże)": [10, 1],
      Oszczep: [15, 1],
    },
    Stronnicy: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],

      "Karwasz bojowy": [15, 0],
      Miecz: [10, 0],
      "Maczuga ogrów": [5, 0],
      "Topór bojowy/Nadziak": [5, 0],
      "Broń miotana (noże)": [10, 1],
      Ołowiomiotacz: [50, 1],
      Lekki: [10, 2, "Zbroja"],
      Średni: [30, 2, "Zbroja"],
      Hełm: [5, 2],
          "Cep bojowy": [10,0],
    },
    Gnoblar: {
      "Buława/Maczuga/Młot bojowy": [5, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      Włócznia: [10, 0],
      "Broń miotana (noże)": [10, 1],
      Oszczep: [15, 1],
      Proca: [5, 1],
      Sieć: [10, 1],
      Lekki: [5, 2, "Zbroja"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
  },
  "Kult Ducha Chaosu": {
    Bohaterowie: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],

      "Gwiazda zaranna": [5, 0],
      Halabarda: [10, 0],
      Kostur: [5, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      Włócznia: [10, 0],
      "Broń miotana (noże)": [10, 1],
      Łuk: [10, 1],
      "Łuk krótki": [5, 1],
      Oszczep: [15, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      "Zbroja Chaosu": [100, 2, "Zbroja"],
      Puklerz: [3, 2, "Tarcza"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
          "Cep bojowy": [10,0],
    },
    Stronnicy: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],

      "Gwiazda zaranna": [5, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      Włócznia: [10, 0],
      "Broń miotana (noże)": [10, 1],
      Oszczep: [15, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Puklerz: [3, 2, "Tarcza"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
          "Cep bojowy": [10,0],
    },
    Ogr: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],

      "Karwasz bojowy": [15, 0],
      Miecz: [10, 0],
      "Maczuga ogrów": [5, 0],
      "Broń miotana (noże)": [10, 1],
      Lekki: [10, 2, "Zbroja"],
      Średni: [30, 2, "Zbroja"],
      Hełm: [5, 2],
          "Cep bojowy": [10,0],
    },
  },
  "Kult Karmazynowej Czaszki": {
    Bohaterowie: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],

      "Gwiazda zaranna": [5, 0],
      Halabarda: [10, 0],
      Korbacz: [5, 0],
      Łamacz: [25, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      Włócznia: [10, 0],
      "Broń miotana (noże)": [10, 1],
      Oszczep: [15, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Ciężki: [30, 2, "Zbroja"],
      "Zbroja Chaosu": [100, 2, "Zbroja"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
          "Cep bojowy": [10,0],
    },
    Stronnicy: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],

      "Gwiazda zaranna": [5, 0],
      Korbacz: [5, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      Włócznia: [10, 0],
      "Broń miotana (noże)": [10, 1],
      Oszczep: [15, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
          "Cep bojowy": [10,0],
    },
    Ogr: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],

      "Karwasz bojowy": [15, 0],
      Miecz: [10, 0],
      "Maczuga ogrów": [5, 0],
      "Broń miotana (noże)": [10, 1],
      Lekki: [10, 2, "Zbroja"],
      Średni: [30, 2, "Zbroja"],
      Hełm: [5, 2],
          "Cep bojowy": [10,0],
    },
  },
  "Kult Dzieci Zagłady": {
    Bohaterowie: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],

      "Gwiazda zaranna": [5, 0],
      Halabarda: [10, 0],
      Korbacz: [5, 0],
      Kosa: [15, 0],
      Kostur: [5, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      Włócznia: [10, 0],
      "Broń miotana (noże)": [10, 1],
      Oszczep: [15, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      "Zbroja Chaosu": [100, 2, "Zbroja"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
          "Cep bojowy": [10,0],
    },
    Stronnicy: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],

      "Gwiazda zaranna": [5, 0],
      Korbacz: [5, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      Włócznia: [10, 0],
      "Broń miotana (noże)": [10, 1],
      Oszczep: [15, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
          "Cep bojowy": [10,0],
    },
    Ogr: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],

      "Karwasz bojowy": [15, 0],
      Miecz: [10, 0],
      "Maczuga ogrów": [5, 0],
      "Broń miotana (noże)": [10, 1],
      Lekki: [10, 2, "Zbroja"],
      Średni: [30, 2, "Zbroja"],
      Hełm: [5, 2],
          "Cep bojowy": [10,0],
    },
  },
  "Kult Sybarytów": {
    Bohaterowie: {
      "Broń wielka": [10, 0],
      Bicz: [15, 0],
      "Gwiazda zaranna": [5, 0],
      Halabarda: [10, 0],
      Łamacz: [25, 0],
      Miecz: [10, 0],
      Rapier: [10, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      Włócznia: [10, 0],
      "Broń miotana (noże)": [10, 1],
      Kusza: [25, 1],
      "Pistolet pojedynkowy": [20,1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      "Zbroja Chaosu": [100, 2, "Zbroja"],
      Puklerz: [3, 2, "Tarcza"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
    Stronnicy: {
      "Broń wielka": [10, 0],
      "Gwiazda zaranna": [5, 0],
      Miecz: [10, 0],
      Rapier: [10, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      Włócznia: [10, 0],
      "Broń miotana (noże)": [10, 1],
      Kusza: [25, 1],
      Oszczep: [15, 1],
      Lekki: [5, 2, "Zbroja"],
      Puklerz: [3, 2, "Tarcza"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
    Ogr: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],

      "Karwasz bojowy": [15, 0],
      Miecz: [10, 0],
      "Maczuga ogrów": [5, 0],
      "Broń miotana (noże)": [10, 1],
      Lekki: [10, 2, "Zbroja"],
      Średni: [30, 2, "Zbroja"],
      Hełm: [5, 2],
          "Cep bojowy": [10,0],
    },
  },
  "Kult Purpurowej Dłoni": {
    Bohaterowie: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Cep bojowy": [10, 0],
      "Gwiazda zaranna": [5, 0],
      Halabarda: [10, 0],
      Łamacz: [25, 0],
      Miecz: [10, 0],
      Rapier: [10, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      Włócznia: [10, 0],
      "Broń miotana (noże)": [10, 1],
      Kusza: [25, 1],
      Oszczep: [15, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      "Zbroja Chaosu": [100, 2, "Zbroja"],
      Puklerz: [3, 2, "Tarcza"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
    Stronnicy: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Cep bojowy": [10, 0],
      "Gwiazda zaranna": [5, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      Włócznia: [10, 0],
      "Broń miotana (noże)": [10, 1],
      Oszczep: [15, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Puklerz: [3, 2, "Tarcza"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
    Ogr: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],

      "Karwasz bojowy": [15, 0],
      Miecz: [10, 0],
      "Maczuga ogrów": [5, 0],
      "Broń miotana (noże)": [10, 1],
      Lekki: [10, 2, "Zbroja"],
      Średni: [30, 2, "Zbroja"],
      Hełm: [5, 2],
          "Cep bojowy": [10,0],
    },
  },
  "Grasanci Chaosu": {
    Bohaterowie: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Cep bojowy": [10, 0],
      "Gwiazda zaranna": [5, 0],
      Halabarda: [10, 0],
      Korbacz: [5, 0],
      Kosa: [15, 0],
      Kostur: [5, 0],
      Łapacz: [10, 0],
      Miecz: [10, 0],
      Rapier: [10, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      Włócznia: [10, 0],

      Oszczep: [15, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Ciężki: [30, 2, "Zbroja"],
      "Zbroja Chaosu": [100, 2, "Zbroja"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
          "Broń miotana (topory/młoty)": [15,1],
    },
    Stronnicy: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Cep bojowy": [10, 0],
      "Gwiazda zaranna": [5, 0],
      Korbacz: [5, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      Włócznia: [10, 0],
      "Broń miotana (topory/młoty)": [15, 1],
      Oszczep: [15, 1],
      Proca: [5, 1],
      Sieć: [10, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
    Ogr: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],

      "Karwasz bojowy": [15, 0],
      Miecz: [10, 0],
      "Maczuga ogrów": [5, 0],
      "Broń miotana (noże)": [10, 1],
      Lekki: [10, 2, "Zbroja"],
      Średni: [30, 2, "Zbroja"],
      Hełm: [5, 2],
          "Cep bojowy": [10,0],
    },
  },
  "Karnawał Chaosu": {
    Bohaterowie: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Cep bojowy": [10, 0],
      "Gwiazda zaranna": [5, 0],
      Halabarda: [10, 0],
      Korbacz: [5, 0],
      Kostur: [5, 0],
      Łapacz: [10, 0],
      Miecz: [10, 0],
      Rapier: [10, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      Włócznia: [10, 0],
      "Broń miotana (noże)": [10, 1],
      Łuk: [10, 1],
      Oszczep: [15, 1],
      Pistolet: [10, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Ciężki: [30,2,"Zbroja"],
      "Zbroja Chaosu": [100, 2, "Zbroja"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
    Stronnicy: {
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Cep bojowy": [10, 0],
      "Gwiazda zaranna": [5, 0],
      Korbacz: [5, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      Włócznia: [10, 0],
      "Broń miotana (noże)": [10, 1],
      Łuk: [10, 1],
      Oszczep: [15, 1],
      Proca: [5, 1],
      Sieć: [10, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
    Ogr: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Cep bojowcy": [10, 0],
      "Karwasz bojowy": [15, 0],
      Miecz: [10, 0],
      "Maczuga ogrów": [5, 0],
      "Broń miotana (noże)": [10, 1],
      Lekki: [10, 2, "Zbroja"],
      Średni: [30, 2, "Zbroja"],
      Hełm: [5, 2],
    },
  "Tyralier": {
      "Buława/Maczuga/Młot bojowy": [5,0],
      "Miecz": [10,0],
      "Sztylet": [2,0],
      "Topór bojowy/Nadziak": [5,0],
      "Włócznia": [10,0],
      "Broń miotana (noże)": [10,1],
      "Łuk": [10,1],
      "Oszczep": [15,1],
      "Lekki": [5,2,"Zbroja"],
      "Tarcza": [5,2,"Tarcza"],
      "Hełm": [5,2]
    },
},
  "Zbrojne stado Zwierzoludzi": {
    Bohaterowie: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Cep bojowy": [10, 0],
      "Gwiazda zaranna": [5, 0],
      Halabarda: [10, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      Włócznia: [10, 0],
      "Broń miotana (noże)": [10, 1],
      Oszczep: [15, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Ciężki: [30, 2, "Zbroja"],
      "Zbroja Chaosu": [100, 2, "Zbroja"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
    Stronnicy: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Cep bojowy": [10, 0],
      "Gwiazda zaranna": [5, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      Włócznia: [10, 0],
      "Broń miotana (noże)": [10, 1],
      Oszczep: [15, 1],
      Sieć: [10, 1],
      Lekki: [5, 2, "Zbroja"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
    Szaman: {
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Gwiazda zaranna": [5, 0],
      "Kostur Rykowca": [10, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      "Broń miotana (noże)": [10, 1],
      Oszczep: [15, 1],
      "Zbroja Chaosu": [100, 2, "Zbroja"],
      "Dziedzina Dziczy": [0, 4, "Choice"],
      "Dziedzina Chaosu": [0, 4, "Choice"],
      "Dziedzina Nurgla": [0, 4, "Choice"],
      "Dziedzina Slaneesha": [0, 4, "Choice"],
      "Dziedzina Tzeentcha": [0, 4, "Choice"],
    },
    Ungor: {
      "Buława/Maczuga/Młot bojowy": [5, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      Włócznia: [10, 0],
      "Broń miotana (noże)": [10, 1],
      Łuk: [10, 1],
      "Łuk krótki": [5, 1],
      Sieć: [10, 1],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
    Minotaur: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],

      "Karwasz bojowy": [15, 0],
      Miecz: [10, 0],
      "Maczuga ogrów": [5, 0],
      "Broń miotana (noże)": [10, 1],
      Lekki: [10, 2, "Zbroja"],
      Średni: [30, 2, "Zbroja"],
      Hełm: [5, 2],
          "Cep bojowy": [10,0],
    },
  },
  "Nieumarła świta hrabiego von Carstein": {
    Bohaterowie: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Gwiazda zaranna": [5, 0],
      Halabarda: [10, 0],
      Kostur: [5, 0],
      Łamacz: [25, 0],
      Miecz: [10, 0],
      Rapier: [10, 0],
      Sztylet: [2, 0],
      Kopia: [30, 0],
      Włócznia: [10, 0],
      "Broń miotana (noże)": [10, 1],
      Łuk: [10, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Ciężki: [30, 2, "Zbroja"],
      Puklerz: [3, 2, "Tarcza"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
    Stronnicy: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Gwiazda zaranna": [5, 0],
      Halabarda: [10, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      Włócznia: [10, 0],
      Łuk: [10, 1],
      Oszczep: [15, 1],
      Sieć: [10, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
  },
  "Nieumarły orszak księżnej Lahmi": {
    Bohaterowie: {
      "Broń wielka": [10, 0],
      Bicz: [15, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Gwiazda zaranna": [5, 0],
      Kostur: [5, 0],
      Miecz: [10, 0],
      Rapier: [10, 0],
      Sztylet: [2, 0],
      Włócznia: [10, 0],
      "Broń miotana (noże)": [10, 1],
      Łuk: [10, 1],
      "Łuk długi": [20, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Ciężki: [30, 2, "Zbroja"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
    Stronnicy: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Gwiazda zaranna": [5, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      Włócznia: [10, 0],
      Łuk: [10, 1],
      Oszczep: [15, 1],
      Sieć: [10, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
  },
  "Nieumarły poczet Krwawego Smoka": {
    Bohaterowie: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Gwiazda zaranna": [5, 0],
      Halabarda: [10, 0],
      Kopia: [30, 0],
      Kostur: [5, 0],
      Łamacz: [25, 0],
      Miecz: [10, 0],
      Mizerykordia: [5, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      Włócznia: [10, 0],
      "Broń miotana (noże)": [10, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Ciężki: [30, 2, "Zbroja"],
      Puklerz: [3, 2, "Tarcza"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
    Stronnicy: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Gwiazda zaranna": [5, 0],
      Halabarda: [10, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      Włócznia: [10, 0],
      Łuk: [10, 1],
      Oszczep: [15, 1],
      Sieć: [10, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],

      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
          "Ciężki": [30,2,"Zbroja"],
    },
    Rycerz: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      Kopia: [30, 0],
      Miecz: [10, 0],
      Mizerykordia: [5, 0],
      Sztylet: [2, 0],
      Włócznia: [10, 0],
      "Broń miotana (noże)": [10, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Ciężki: [30, 2, "Zbroja"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
  },
  "Nieumarły sabat rodu Nekrarch": {
    Nekrarcha: {
      Kostur: [5, 0],
      Chopesz: [10, 0],
      Sztylet: [2, 0],
      "Broń miotana (noże)": [10, 1],
    },
    Bohaterowie: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      Chopesz: [10, 0],
      "Gwiazda zaranna": [5, 0],
      Halabarda: [10, 0],
      Korbacz: [10, 0],
      Kostur: [5, 0],
      Sztylet: [2, 0],
      Włócznia: [10, 0],
      "Broń miotana (noże)": [10, 1],
      Kusza: [25, 1],
      Łuk: [10, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Ciężki: [30, 2, "Zbroja"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
    Stronnicy: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Gwiazda zaranna": [5, 0],
      Chopesz: [10, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      Włócznia: [10, 0],
      Łuk: [10, 1],
      Oszczep: [15, 1],
      Sieć: [10, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
  },
  "Nieumarły tabor ludu Strigosu": {
    Bohaterowie: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Gwiazda zaranna": [5, 0],
      Halabarda: [10, 0],
      Kostur: [5, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      Włócznia: [10, 0],
      "Broń miotana (noże)": [10, 1],
      Kusza: [25, 1],
      Łuk: [10, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Ciężki: [30, 2, "Zbroja"],
      Puklerz: [3, 2, "Tarcza"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
    Stronnicy: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Gwiazda zaranna": [5, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      Włócznia: [10, 0],
      Łuk: [10, 1],
      Oszczep: [15, 1],
      Sieć: [10, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
  },
  "Nieumarła horda Liczmistrza": {
    Liczmistrz: {
      Kostur: [5, 0],
      Chopesz: [10, 0],
      Sztylet: [2, 0],
      "Broń miotana (noże)": [10, 1],
    },
    Bohaterowie: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Gwiazda zaranna": [5, 0],
      Chopesz: [10, 0],
      Korbacz: [10, 0],
      Sztylet: [2, 0],
      Włócznia: [10, 0],
      "Broń miotana (noże)": [10, 1],
      Kusza: [25, 1],
      Łuk: [10, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Ciężki: [30, 2, "Zbroja"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
    Stronnicy: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Gwiazda zaranna": [5, 0],
      Chopesz: [10, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      Włócznia: [10, 0],
      Łuk: [10, 1],
      Oszczep: [15, 1],
      Sieć: [10, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
    Rycerz: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      Kopia: [30, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      Włócznia: [10, 0],
      "Broń miotana (noże)": [10, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Ciężki: [30, 2, "Zbroja"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
  },
  "Nieumarły zastęp z Nehekhary": {
    Bohaterowie: {
      "Broń wielka": [10, 0],
      Bicz: [15, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      Chopesz: [10, 0],
      "Gwiazda zaranna": [5, 0],
      Halabarda: [10, 0],
      Korbacz: [5, 0],
      Kostur: [5, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      Włócznia: [10, 0],
      "Broń miotana (noże)": [10, 1],
      Łuk: [10, 1],
      "Łuk długi": [20, 1],
      Oszczep: [15, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Ciężki: [30, 2, "Zbroja"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
    Licz: {
      "Broń wielka": [10, 0],
      Bicz: [15, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      Chopesz: [10, 0],
      "Gwiazda zaranna": [5, 0],
      Halabarda: [10, 0],
      Korbacz: [5, 0],
      Kostur: [5, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      Włócznia: [10, 0],
      "Broń miotana (noże)": [10, 1],
      Łuk: [10, 1],
      "Łuk długi": [20, 1],
      Oszczep: [15, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Ciężki: [30, 2, "Zbroja"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
      "Tradycja Światła": [0, 4, "Choice"],
      "Tradycja Śmierci": [0, 4, "Choice"],
    },
    Stronnicy: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      Chopesz: [10, 0],
      "Gwiazda zaranna": [5, 0],
      Korbacz: [5, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      Włócznia: [10, 0],
      "Broń miotana (noże)": [10, 1],
      Łuk: [10, 1],
      "Łuk długi": [20, 1],
      Oszczep: [15, 1],
      Sieć: [10, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
    Ushabti: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      Chopesz: [10, 0],
      "Gwiazda zaranna": [5, 0],
      Korbacz: [5, 0],
      "Topór bojowy/Nadziak": [5, 0],
      Włócznia: [10, 0],
      "Broń miotana (noże)": [10, 1],
      Łuk: [10, 1],
      "Łuk długi": [20, 1],
      Oszczep: [15, 1],
      Sieć: [10, 1],
      Lekki: [10, 2, "Zbroja"],
      Średni: [30, 2, "Zbroja"],
      Hełm: [5, 2],
    },
  },
  "Zwiadowcze stado klanu Eshin": {
    Bohaterowie: {
      Halabarda: [10, 0],
      Katana: [10, 0],
      Korbacz: [5, 0],
      Kostur: [5, 0],
      Khutar: [30, 0],
      Łapacz: [10, 0],
      Spaczkhutar: [40, 0],
      Sztylet: [2, 0],
      Wakizashi: [5, 0],
      Włócznia: [10, 0],
      "Broń miotana (gwiazdki)": [10, 1],
      Dmuchawka: [15, 1],
      "Granat dymny": [25, 1],
      "Kusza powtarzalna": [25, 1],
      Proca: [5, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Puklerz: [3, 2, "Tarcza"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
    Stronnicy: {
      Korbacz: [5, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      Wakizashi: [5, 0],
      Włócznia: [10, 0],
      "Broń miotana (gwiazdki)": [10, 1],
      Proca: [5, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Hełm: [5, 2],
    },
    Rynsztokowiec: {
      Halabarda: [10, 0],
      Katana: [10, 0],
      Korbacz: [5, 0],
      Khutar: [30, 0],
      Sztylet: [2, 0],
      Wakizashi: [5, 0],
      Włócznia: [10, 0],
      "Broń miotana (gwiazdki)": [10, 1],
      Proca: [5, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Hełm: [5, 2],
          "Sieć": [10,1],
    },
  },
  "Poganiacze klanu Moulder": {
    Bohaterowie: {
      Bicz: [15, 0],
      Halabarda: [10, 0],
      Korbacz: [5, 0],
      Łapacz: [10, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      Trójząb: [15, 0],
      Włócznia: [10, 0],
      "Broń miotana (gwiazdki)": [10, 1],
      Kusza: [25, 1],
      Proca: [5, 1],
      Sieć: [10, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
    Stronnicy: {
      Halabarda: [10, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      Włócznia: [10, 0],
      "Broń miotana (gwiazdki)": [10, 1],
      Proca: [5, 1],
      Sieć: [10, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
  },
  "Kult Zarazy klanu Pestilens": {
    Bohaterowie: {
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Cep bojowy": [10, 0],
      Halabarda: [10, 0],
      "Kadzielnica zarazy": [25, 0],
      Korbacz: [5, 0],
      Kostur: [5, 0],
      Łapacz: [10, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      Włócznia: [10, 0],
      "Broń miotana (gwiazdki)": [10, 1],
      Proca: [5, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],

      Hełm: [5, 2],
          "Ciężki": [30,2,"Zbroja"],
    },
    Stronnicy: {
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Cep bojowy": [10, 0],
      Halabarda: [10, 0],
      Korbacz: [5, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      Włócznia: [10, 0],
      "Broń miotana (gwiazdki)": [10, 1],
      Proca: [5, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Hełm: [5, 2],
    },
    Siewca: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Cep bojowy": [10, 0],
      "Gwiazda zaranna": [5, 0],
      Korbacz: [5, 0],
    },
  },
  "Harcownicy klanu Skryre": {
    Bohaterowie: {
      "Buława/Maczuga/Młot bojowy": [5, 0],
      Halabarda: [10, 0],
      Korbacz: [5, 0],
      Łapacz: [10, 0],
      Miecz: [10, 0],
      Spaczhalabarda: [20, 0],
      Sztylet: [2, 0],
      Włócznia: [10, 0],
      "Broń miotana (gwiazdki)": [10, 1],
      "Kula trującego wichru": [35, 1],
      "Kusza powtarzalna": [25, 1],
      Oszczep: [15, 1],
      Proca: [5, 1],
      Spaczpistolet: [25, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Ciężki: [30, 2, "Zbroja"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
    Stronnicy: {
      "Buława/Maczuga/Młot bojowy": [5, 0],
      Halabarda: [10, 0],
      Korbacz: [5, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      Włócznia: [10, 0],
      "Broń miotana (gwiazdki)": [10, 1],
      Spaczmuszkiet: [30, 1],
      Proca: [5, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
    Ciężcy: {
      "Buława/Maczuga/Młot bojowy": [5, 0],
      Korbacz: [5, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      Włócznia: [10, 0],
      Kulomiot: [50,1],
      "Miotacz spaczognia": [50,1],
      "Moździerz trującego wichru": [50,1],
      Spaczrusznica: [50, 3, "Choice"],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Hełm: [5, 2],
          "Spaczrusznica i pawęża": [50,1],
    },
    Szczurogr: {
      Kulomiot: [50, 3, "Choice"],
      "Miotacz spaczognia": [50, 3, "Choice"],
      "Moździerz trującego wichru": [50, 3, "Choice"],
      Spaczrusznica: [50, 3, "Choice"],
    },
  },
  "Zbrojne stado klanu Mors": {
    Bohaterowie: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Cep bojowy": [10, 0],
      "Gwiazda zaranna": [5, 0],
      Halabarda: [10, 0],
      Korbacz: [5, 0],
      Kostur: [5, 0],
      Łamacz: [25, 0],
      Łapacz: [10, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      Włócznia: [10, 0],
      "Broń miotana (gwiazdki)": [10, 1],
      "Kusza powtarzalna": [25, 1],
      Pistolet: [10, 1],
      Proca: [5, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Ciężki: [30, 2, "Zbroja"],
      Puklerz: [3, 2, "Tarcza"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
    Stronnicy: {
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Cep bojowy": [10, 0],
      "Gwiazda zaranna": [5, 0],
      Halabarda: [10, 0],
      Korbacz: [5, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      Włócznia: [10, 0],
      "Broń miotana (gwiazdki)": [10, 1],
      Kusza: [25, 1],
      Oszczep: [15, 1],
      Proca: [5, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
    Szturmoszczur: {
      "Broń wielka": [10, 0],
      Halabarda: [10, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      Włócznia: [10, 0],
      "Broń miotana (gwiazdki)": [10, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Ciężki: [30, 2, "Zbroja"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
  },
  "Łowcze plemię Dzikich Orków": {
    Bohaterowie: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Gwiazda zaranna": [5, 0],
      Kostur: [5, 0],
      Miecz: [10, 0],
      Rembak: [5, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      Włócznia: [10, 0],
      "Broń miotana (noże)": [10, 1],
      Łuk: [10, 1],
      Oszczep: [15, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
    "Dziki Ork": {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Gwiazda zaranna": [5, 0],
      Rembak: [5, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      Włócznia: [10, 0],
      "Broń miotana (noże)": [10, 1],
      Łuk: [10, 1],
      Lekki: [5, 2, "Zbroja"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
    Dźgacze: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Gwiazda zaranna": [5, 0],
      "Duża dźgacz": [30, 0],
      Rembak: [5, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      Włócznia: [10, 0],
      "Broń miotana (noże)": [10, 1],
      Łuk: [10, 1],
      Lekki: [5, 2, "Zbroja"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
    "Leśny Goblin": {
      "Buława/Maczuga/Młot bojowy": [5, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      Trójząb: [15, 0],
      Włócznia: [10, 0],
      "Broń miotana (noże)": [10, 1],
      "Łuk krótki": [5, 1],
      Oszczep: [15, 1],
      Sieć: [10, 1],
      Lekki: [5, 2, "Zbroja"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
  },
  "Plemię Leśnych Goblinów": {
    Bohaterowie: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Gwiazda zaranna": [5, 0],
      Kostur: [5, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      Trójząb: [15, 0],
      Włócznia: [10, 0],
      "Broń miotana (noże)": [10, 1],
      Dmuchawka: [15, 1],
      "Łuk krótki": [5, 1],
      Łuk: [10, 1],
      Oszczep: [15, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
    Stronnicy: {
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Gwiazda zaranna": [5, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      Trójząb: [15, 0],
      Włócznia: [10, 0],
      "Broń miotana (noże)": [10, 1],
      Dmuchawka: [15, 1],
      "Łuk krótki": [5, 1],
      Łuk: [10, 1],
      Proca: [5, 1],
      Sieć: [10, 1],
      Lekki: [5, 2, "Zbroja"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
  },
  "Orkowie & Gobliny": {
    Bohaterowie: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Gwiazda zaranna": [5, 0],
      Kostur: [5, 0],
      Miecz: [10, 0],
      Rembak: [5, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      Włócznia: [10, 0],
      "Broń miotana (noże)": [10, 1],
      Kusza: [25, 1],
      Łuk: [10, 1],
      Oszczep: [15, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Ciężki: [30, 2, "Zbroja"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
    Ork: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Gwiazda zaranna": [5, 0],
      Rembak: [5, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      Włócznia: [10, 0],
      "Broń miotana (noże)": [10, 1],
      Kusza: [25, 1],
      Łuk: [10, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
    Goblin: {
      "Buława/Maczuga/Młot bojowy": [5, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      Trójząb: [15, 0],
      Włócznia: [10, 0],
      "Broń miotana (noże)": [10, 1],
      "Łuk krótki": [5, 1],
      Oszczep: [15, 1],
      Sieć: [10, 1],
      Lekki: [5, 2, "Zbroja"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
  },
  "Nocne Gobliny": {
    Bohaterowie: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Gwiazda zaranna": [5, 0],
      Kopia: [30, 0],
      Kostur: [5, 0],
      Łapacz: [10, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      Trójząb: [15, 0],
      Włócznia: [10, 0],
      "Broń miotana (noże)": [10, 1],
      Dmuchawka: [15, 1],
      "Łuk krótki": [5, 1],
      Łuk: [10, 1],
      Oszczep: [15, 1],
      Sieć: [10, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Ciężki: [30, 2, "Zbroja"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
    Stronnicy: {
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Gwiazda zaranna": [5, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      Trójząb: [15, 0],
      Włócznia: [10, 0],
      "Broń miotana (noże)": [10, 1],
      Dmuchawka: [15, 1],
      "Łuk krótki": [5, 1],
      Łuk: [10, 1],
      Sieć: [10, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
    Hop: {
      "Buława/Maczuga/Młot bojowy": [5, 0],
      Kopia: [30, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      Trójząb: [15, 0],
      Włócznia: [10, 0],
      "Broń miotana (noże)": [10, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Ciężki: [30, 2, "Zbroja"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
  },
  "Załoga Zielonoskórych Kaprów": {
    Bohaterowie: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Gwiazda zaranna": [5, 0],
      Halabarda: [10, 0],
      Kostur: [5, 0],
      Łapacz: [10, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      Trójząb: [15, 0],
      Włócznia: [10, 0],
      "Broń miotana (noże)": [10, 1],
      "Łuk krótki": [5, 1],
      Łuk: [10, 1],
      Kusza: [25, 1],
      Pistolet: [10, 1],
      "Pistolet pojedynkowy": [20, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Ciężki: [30, 2, "Zbroja"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
    Stronnicy: {
      Bosak: [15, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Gwiazda zaranna": [5, 0],
      Halabarda: [10, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      Trójząb: [15, 0],
      Włócznia: [10, 0],
      "Broń miotana (noże)": [10, 1],
      Garłacz: [30, 1],
      Łuk: [10, 1],
      Kusza: [25, 1],
      Muszkiet: [25, 1],
      Oszczep: [15, 1],
      Sieć: [10, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
    Ciężcy: {
      Sztylet: [2, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      Harpun: [50, 3, "Choice"],
      Ołowiomiotacz: [50, 3, "Choice"],
      Lekki: [5, 2, "Zbroja"],
      Hełm: [5, 2],
    },
    Kaper: {
      Bosak: [15, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      "Cep bojowy": [10, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      "Broń miotana (noże)": [10, 1],
      Garłacz: [30, 1],
      Pistolet: [10, 1],
      "Pistolet pojedynkowy": [20, 1],
    },
  },
  "Jaszczuroludzie z Lustrii": {
    Skink: {
      "Buława/Maczuga/Młot bojowy": [5, 0],
      Kostur: [5, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      Włócznia: [10, 0],
      "Broń miotana (noże)": [10, 1],
      Dmuchawka: [15, 1],
      Oszczep: [15, 1],
      Sieć: [10, 1],
      Lekki: [5, 2, "Zbroja"],
      Średni: [15, 2, "Zbroja"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
    Saurus: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      Halabarda: [10, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      Włócznia: [10, 0],
      "Broń miotana (noże)": [10, 1],
      Oszczep: [15, 1],
      Lekki: [5, 2, "Zbroja"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
    Kroxigor: {
      "Broń wielka": [10, 0],
      "Buława/Maczuga/Młot bojowy": [5, 0],
      Halabarda: [10, 0],
      Miecz: [10, 0],
      "Topór bojowy/Nadziak": [5, 0],
      Włócznia: [10, 0],
      "Broń miotana (noże)": [10, 1],
      Lekki: [10, 2, "Zbroja"],
      Tarcza: [5, 2, "Tarcza"],
      Hełm: [5, 2],
    },
    Kapłan: {
      Kostur: [5, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      Włócznia: [10, 0],
      "Broń miotana (noże)": [10, 1],
    },
  },
};
